import { Biometrics } from './biometricsClass';

export class BiometricsService {
    private static biometrics: Promise<Biometrics> | undefined;

    protected static async buildBiometricsInstance() {
        return new Biometrics();
    }

    public static getBiometrics() {
        if (this.biometrics) {
            return this.biometrics;
        }
        this.biometrics = this.buildBiometricsInstance();
        return this.biometrics;
    }
}
